import {Injectable} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';

@Injectable({
    providedIn: 'root'
})
export class AuthRestService {

    constructor(private keycloakService: KeycloakService) {}

    logout(): void {
        this.keycloakService.logout(window.location.origin);
    }
}
